import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { FormInput } from "@/shared/components";

export function Channel(props: { pending: boolean }) {
  const { pending } = props;

  const {
    formState: { errors },
  } = useFormContext();

  const getErrorText = () => {
    if (
      errors.channel_of_communications?.type === "required" ||
      errors.channel_of_communications?.type === "validate"
    ) {
      return "This field must contain 2-100 symbols";
    }

    return null;
  };

  return (
    <FormInput
      name="channel_of_communications"
      rules={{
        required: true,
        validate: (value) => {
          const trimmedValue = (value || "").trim();
          const validValue =
            trimmedValue.length >= 2 && trimmedValue.length <= 100;

          return validValue;
        },
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label="Recommended channel of communication"
          variant="filled"
          disabled={pending}
          error={!!getErrorText()}
          helperText={getErrorText()}
        />
      )}
    />
  );
}
